import { isLoading } from 'resift';

function getIsLoading(status: any) {
  if (typeof status === 'number') {
    return isLoading(status);
  }

  return status.isLoading();
}

export default getIsLoading;
